import { useEffect, useRef, useState } from "react";
import styles from "./DropdownMenu.module.scss";

type Props = {
  title: string;
  text: string;
  icon?: string;
  href: string;
  list: {
    title?: string;
    href: string;
    text: string;
  }[];
  listStyle?: Object;
};

const DropdownMenu = ({
  title,
  text,
  href,
  icon,
  list,
  listStyle = {},
}: Props) => {
  const [showMenu, setShowMenu] = useState(false);
  const dropdownWrapper = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleEvent = (e: Event) => {
      if (!dropdownWrapper.current?.contains(e.target as Node)) {
        setShowMenu(false);
      }
    };
    if (showMenu) {
      document.addEventListener("click", handleEvent);
      document.addEventListener("focus", handleEvent);
    }
    return () => {
      if (showMenu) {
        document.removeEventListener("click", handleEvent);
        document.removeEventListener("focus", handleEvent);
      }
    };
  }, [showMenu]);
  return (
    <div className={styles.dropdownWrapper} ref={dropdownWrapper}>
      <div className={styles.dropdownButton}>
        <a href={href} data-hover="true" title={title}>
          <i className="material-icons" aria-hidden="true" data-icon={icon}></i>
          <span dangerouslySetInnerHTML={{ __html: text }}></span>
          <i
            className="material-icons right"
            data-icon="arrow_drop_down"
            onClick={(e) => {
              e.preventDefault();
              setShowMenu(!showMenu);
            }}
          ></i>
        </a>
      </div>
      <ul
        className={`${styles.dropdownList} ${
          showMenu ? styles.dropdownListShow : ""
        } z-10`}
        style={listStyle}
      >
        {list.map(({ title, href, text }) => {
          return (
            <li key={href} className={`${styles.dropdownItem} bg-white`}>
              <a href={href} title={title}>
                {text}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export { DropdownMenu, DropdownMenu as default };
